export const pt_br = {
    message: {
        common: {
            collaborators: 'Colaboradores',
            my_profile: 'Meu Perfil',
            user: 'Usuário',
            password: 'Senha',
            confirm: 'Confirmar',
            back: 'Voltar',
            filters: 'Filtros',
            filters_text: 'Filtros referentes a',
            adm: 'Administrador',
            master: 'Administrador Master',
            /* Vem do banco */ bdm: 'BDM',
            /* Vem do banco */ eng: 'Engenheiro',
            /* Vem do banco */ managers: 'Gerente',
            /* Vem do banco */ inside: "Inside",
            /* Vem do banco */ seller: "Vendedor",
            /* Vem do banco */ adm_brand: 'Administradores de marca',
            /* Vem do banco */ intermediary: 'Intermediário',
            sellers: "Vendedores",
            clear: 'Limpar',
            apply: 'Aplicar',
            brands: 'Marcas',
            resales: 'Parceiros de Negócios',
            goals: 'Metas',
            yes: 'Sim',
            atention: 'Atenção',
            session_expired_message: 'Sua sessão foi expirada, favor se logar novamente',
            exit_message: 'Certeza que deseja sair?',
            version: 'Versão',
            profile: 'Alterar foto de perfil',
            rights_reserved: 'Aurora, todos os direitos reservados.',
            from: 'De:',
            to: 'Até:',
            from_elipssis: 'De...',
            to_elipssis: 'Até...',
            future_commission: 'Comissão Futura',
            goal_name: 'Nome da meta',
            goal_name_elipssis: 'Nome da meta...',
            role: 'Função',
            role_elipssis: 'Função...',
            orientation: 'Orientação',
            goal_orientation: 'Orientação da meta',
            margin: 'Margem',
            range: 'Faixa',
            period: 'Período',
            commission: 'Comissão',
            name: 'Nome',
            name_elipssis: 'Nome...',
            performer: 'Performante',
            performer_elipssis: 'Performante...',
            title: 'Título da meta',
            brand: 'Marca',
            warehouse: 'Depósito',
            cost_center: 'Centro de Custo',
            triggers: 'Gatilhos',
            seasonality: 'Sazonalidade',
            Seasonalities: 'Sazonalidades',
            required: 'Obrigatório',
            required_field: 'Campo obrigatório',
            cross: 'Cross',
            transfer: 'Transferência',
            sale_goal: 'Saldão',
            /* Problema na hora de inserir */ no_information: 'Sem informações para exibição',
            success: 'Sucesso!',
            status: 'Status',
            export: 'Exportar',
            invoice: 'Nota Fiscal',
            billing_date: 'Data de Faturamento',
            total_sales: 'Total de Venda',
            type_note: 'Tipo',
            line: 'Linha',
            quantity: 'Quantidade',
            commissioning: 'Comissionamento',
            part_number: 'Part Number',
            installment: 'Parcela',
            installments: 'Parcelas',
            duedate: 'Vencimento',
            display: 'Exibir',
            hide: 'Esconder',
            /* Problema na hora de inserir */ select: 'Selecione',
            sap_code: 'Código no SAP',
            options: 'Opções',
            search: 'Pesquisar na tabela...',
            edit: 'Editar',
            deactivate: 'Inativar',
            type_confirm: 'Digite “SIM” para confirmar',
            continue: 'Continuar',
            no: 'Não',
            description: 'Descrição',
            goal_not_found: 'Meta não encontrada',
            brand_not_found: 'Marca não encontrada',
            partner_not_found: 'Parceiro de Negócios não encontrado',
            warehouse_not_found: 'Depósito não encontrado',
            goal_create_fail: 'Erro ao criar meta',
            goal_create_success: 'Meta criada com sucesso',
            goal_update_success: 'Meta atualizada com sucesso',
            goal_update_fail: 'Erro ao atualizar meta',
            not_allowed: 'Não permitido',
            not_defined: 'Não definido',
            portuguese: 'Português',
            spanish: 'Espanhol',
            english: 'Inglês',
            sellerName: 'Nome do vendedor',
            register: 'Cadastrar ',
            update: 'Atualizar ',
            data_updated: 'Seus dados foram atualizados com sucesso',
            unexpected_error: 'Ocorreu um erro inesperado no sistema, por favor contacte o suporte',
            select_collaborator: 'Selecione o(a) colaborador(a)',
            word_validation: 'É necessário inserir a palavra para continuar!',
            word_validation_error: 'A palavra inserida é diferente da palavra solicitada!',
            created_text: 'foi criada com sucesso!',
            updated_text: 'foi atualizada com sucesso!',
            deactivated_text: 'foi inativada com sucesso!',
            select_hiring: 'Selecione o modelo de contratação do usuário!',
            wrong_credentials: 'Informações de usuário ou senha incorretas',
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
            locale: 'ptBR',
            to_locale: 'de',
            to_date: 'de',
            date_connection: 'à',
            current_month: 'Mês atual',
            last_month: 'Mês passado',
            home_description_image: '/description_ptbr.png',
            web_title: `Comissão de Vendas`,
            information: 'As informações deste portal são atualizadas diariamente durante o período da noite, além disso, as notas fiscais são adicionadas no portal dois dias após information serem faturadas.',
            invoiced_status: 'faturado',
            employee_role: 'Função do colaborador',
        },
        login: {
            welcome: 'Bem vindo!',
            form_user: 'Preencha os campos abaixo corretamente para acessar a plataforma',
            user_computer: 'Usuário do computador',
            enter: 'Entrar',
            policy: 'Política de Privacidade',
            policy_document_link: '/documents/Política_de_Privacidade.pdf',
            new_way: 'Um novo jeito de visualizar as informações das suas vendas',
            query: 'Consulte os dados referentes as suas metas, vendas e comissões de maneira fácil e rápida',
            cookies: 'Para oferecer a melhor experiência possível em nosso site, utilizamos cookies. Ao continuar navegando, você concorda com o uso desses cookies. Eles são essenciais para garantir funcionalidades como o login seguro. Saiba mais em nossa Política de Privacidade',
            agree: 'Concordo',
        },
        home: {
            greeting: 'Seja bem-vindo(a) ao Portal Comissão de Vendas',
            values: ' valores',
            search_for_collaborator: 'Buscar colaborador',
            filter_functions: 'Filtro de Funções',
            select_function: 'Selecione a função desejada',
            commission: 'Comissão a receber',
            progress_goals: 'Progresso das metas no mês vigente',
            more_details: 'Ver mais detalhes',
            showing: 'Mostrando',
            results: 'de {number} resultados',
        },
        goals: {
            filter_goals: 'Filtrar metas por',
            export: 'Exportar metas',
            register: 'Cadastrar nova meta',
            date_filter: 'Filtro de datas',
            select: 'Selecione o mês/ano ou período desejado',
            closed: 'Metas fechadas',
            goal_found: 'Nenhuma meta encontrada',
        },
        goals_create: {
            employee_information: 'Informações colaborador',
            information_goal: 'As informações a seguir são válidas para o grupo de metas',
            employee: 'Colaborador',
            goal_registration: 'Cadastro de metas',
            fill_field: 'Preencha esse campo para título meta...',
            resale: 'Parceiro de Negócios',
            choose_brand: 'Escolha a marca',
            choose_cost_center: 'Escolha os centros de custo',
            choose_resale: 'Escolha o parceiro de negócios',
            choose_deposits: 'Escolha os depósitos',
            period: 'Definição do período',
            from_goals: 'A partir de',
            to_goals: 'Até',
            optional: 'Configurações opcionais',
            add_goal: 'Adicionar meta',
            action: 'Ação',
            complete_registration: 'Concluir cadastro',
            goals_created: 'Metas foram criadas com sucesso!',
            ok: 'OK',
            goal_updated: 'Meta alterada com sucesso',
        },
        goals_details: {
            details: 'Detalhamento de metas',
            employee_name: 'Nome do colaborador',
            active: 'Ativa',
            inactive: 'Inativa',
            inactive_goal: 'META INATIVA',
            reason: 'Motivo',
            search_brand: 'Pesquisar marcas...',
            search_resale: 'Pesquisar parceiros de negócios...',
            search_warehouse: 'Pesquisar depósitos...',
            search_cost_centers: 'Pesquisar centros de custo...',
            change_goal: 'Alterar',
            save: 'Salvar',
            jan: 'Jan',
            feb: 'Fev',
            mar: 'Mar',
            apr: 'Abr',
            may: 'Mai',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Ago',
            sep: 'Set',
            oct: 'Out',
            nov: 'Nov',
            dec: 'Dez',
            not_applicable: 'Não se aplica',
            close_goal: 'Encerrar meta',
            brands_add: 'Marca(s) a ser(em) adicionada(s)',
            choose_brands: 'Escolha a(s) Marca(s) para adicionar',
            cost_centers: 'Centros de custo',
            cost_center_to_add: 'Centro(s) de custo a ser(em) adicionado(s)',
            choose_cost_centers_to_add: 'Escolha o(s) centro(s) de custo para adicionar',
        },
        goals_delete: {
            close_goal: 'Deseja encerrar a meta?',
            reason: 'Digite o motivo do encerramento',
            goal_closed: 'Meta encerrada com sucesso',
            delete_text: 'Deseja realmente excluir a meta',
            delete_period: 'Período de',
            to: 'até',
        },
        invoices: {
            notes: 'Notas',
            filter_notes: 'Filtrar notas por',
            note_filter: 'Filtro de notas',
            select_date: 'Selecione data de “De” e de “Até”',
            refine_notes: 'Refine sua pesquisa por notas abaixo',
            note_number: 'Número da nota:',
            note: 'Nota...',
            customer_name: 'Nome do Cliente:',
            customer: 'Cliente...',
            resale_name: 'Nome do parceiro de negócios:',
            resale_name_: 'Nome do parceiro de negócios',
            resale_notes: 'Parceiro de Negócios...',
        },
        billing_notes: {
            billing_notes: 'Notas de Faturamento',
            receiving_notes: 'Notas de Recebimento',
            resale_code: 'Código do Parceiro',
            resale_name_note: 'Nome do Parceiro',
            customer_code: 'Código Cliente',
            customer_name_code: 'Nome Cliente',
            total_resale: 'Total do Parceiro',
            base_note: 'Base',
            display_commissions: 'Exibir comissões',
            category: 'Categoria',
        },
        receipt_notes: {
            installments: 'Parcelas',
            receiptDate: 'Data de Recebimento',
            totalmargin: 'Total margem',
            installmentmargin: 'Margem parcela',
        },
        reports: {
            reports: 'Relatórios',
            report_type: 'Selecione o tipo de relatório',
            select_month: 'Selecione o mês',
            report_title_monthly_available: 'Comissão Mensal Disponível',
            report_title_provision: 'Provisão Comissão (Conferência)',
            report_title_summary: 'Resumo de Faturamento do Mês',
            report_title_individual: 'Comissão Individual',
            report_title_available_goal: 'Comissões Disponíveis por Meta',
            report_title_future: 'Comissões Futuras',
            report_title_billing: 'Notas Faturamento',
            report_title_receipt: 'Notas Recebimento',
            report_title_cost_center: 'Totalização por Centro de Custo',
            report_title_dre: 'DRE por Colaborador',
            report_description_monthly_available: "Relatório contendo o somatório de faturamento e o somatório de comissões disponíveis no mês do colaborador",
            report_description_provision: "Relatório contendo o faturamento e as comissões disponíveis no mês, separado por meta do colaborador",
            report_description_summary: "Relatório contendo o \"Resumo de Faturamento do Mês\" como visto no perfil do colaborador",
            report_description_individual: "Relatório contendo as \"Comissões Disponíveis\" como visto no perfil do colaborador",
            report_description_available_goal: "Relatório contendo as \"Comissões Disponíveis\" no mês separadas por meta do colaborador",
            report_description_future: "Relatório contendo as \"Comissões Futuras\" como visto no perfil do colaborador",
            report_description_billing: "Relatório contendo as notas faturadas no período buscado",
            report_description_receipt: "Relatório contendo as notas com recebimento no período buscado",
            report_description_cost_center: "Relatório contendo o faturamento do mês separado por \"Centro de Custo\"",
            report_description_dre: "Relatório contendo o DRE do mês selecionado para o colaborador selecionado",
        },
        brands_create: {
            brand_registration: 'Cadastro de Marca',
            brands_name: 'Nome correspondente à marca',
            sap_identifier: 'Identificador da marca no SAP',
            brand_logo: 'Logo da Marca',
            file_name: 'Nome do arquivo...',
            upload_image: 'Fazer upload da imagem',
            register_brand: 'Cadastrar marca',
            update_brand: 'atualizar marca',
        },
        brands_table: {
            brand_table: 'Nome da marca',
        },
        brands_delete: {
            deactivate_brand: 'Deseja realmente inativar a marca',
        },
        warehouse_create: {
            warehouses: 'Depósitos',
            warehouse_title: 'Nome do depósito',
            warehouse_registration: 'Cadastro de depósito',
            warehouse_name: 'Nome correspondente ao depósito',
            sap_identifier_warehouse: 'Identificador do depósito no SAP',
            warehouse_base: 'Base do Depósito',
            warehouse_created: 'Depósito foi criado com sucesso!',
        },
        warehouse_table: {
            search_deposit: 'Pesquisar na tabela',
        },
        warehouse_delete: {
            confirm_dactivate_warehouse: 'Deseja realmente inativar o depósito',
        },
        resale_delete: {
            confirm_dactivate_resale: 'Deseja realmente inativar o parceiro de negócios',
        },
        resale_create: {
            title: 'Cadastro do Parceiro de Negócios',
            cnpj: 'CNPJ do Parceiro de Negócios',
            placeholder_code: 'Identificador do Parceiro',
            value: 'Valor',
            resale_code: 'Código do Parceiro',
        },
        contributor_summary: {
            value_month: 'Valores referentes a {value}',
            revenue_margin: 'Margem de Faturamento',
            total_revenue: 'Faturamento Total',
            commission_available: 'Comissão Disponível',
            progress_in_the_month: 'Progresso das metas no mês',
            active_goals: 'Metas ativas',
            dont_apply: '- os filtros não se aplica aqui',
            all_goals: 'Ver todas as metas',
            summary_margin: 'Resumo de margem do mês',
            progress: 'Progresso',
            color: 'Cor',
            trigger: 'Gatilho',
            blue_message: 'Meta em progresso',
            green_message: 'Meta atingida e contabiliza performante',
            grey_message: 'Meta não contabiliza performante',
            available_commissions: 'Comissões Disponíveis',
            future_commissions: 'Comissões Futuras',
            annual_billing: 'Faturamento Anual',
            annual_goal: 'Meta Anual',
            goal_group: 'Grupo de Metas',
            annual_margin: 'Margem Anual',
        },
        results: {
            customer: 'Cliente',
            number_installments: 'Qtd Parcelas',
            invoicing_number: 'Data de faturamento',
            receipt_date: 'Data de recebimento',
            total_margin: 'Total Margem',
            installment_margin: 'Margem Parcela',
            goal: 'Meta',
        },
        future_commisions: {
            line_red: 'Linhas em vermelho indicam notas fiscais com pendência financeira',
        },
        settings: {
            settings: 'Configurações',
            users: 'Usuários',
            available_users: 'Usuários Disponíveis',
            register: 'Cadastro',
            registration_SAP: 'Registro no SAP',
            code: 'Código',
            permission: 'Permissão',
            master: 'Administrador master',
            hiring_model: 'Modelo de Contratação',
            new_user: 'Criar novo',
            select_user: 'Selecione um usuário disponível na tabela ao lado para fazer seu cadastro na plataforma.',
            search_table: 'Pesquisa na tabela',
            user_name: 'Nome do usuário',
            permissions: 'Permissões',
            action_inactivate: 'Deseja Realmente inativar o usuário',
        },
        role: {
            function_title: 'Funções',
            registration_function_title: 'Cadastro de Funções',
            name_function: 'Nome da Função',
            description_function: 'Descrição da Função',
            register_function: 'Cadastrar Função',
            ok: 'ok',
            action_inactivate_role: 'Deseja Realmente inativar a função',
        },
        seasoning: {
            register_seasonality_title: 'Cadastro de Sazonalidade',
            seasonality_title: 'Nome da sazonalidade',
            name_seasonality: 'Nome correspondente a sazonalidade',
            description_seasonality: 'Descrição correspondente a sazonalidade',
            start_date: 'Data de início',
            end_date: 'Data de fim',
            type_seasonality: 'Selecione o tipo de sazonalidade que irá cadastrar',
            monthly: 'Mensal',
            quarter: 'Quarter',
            value: 'Valor',
            register_seasonality: 'Atenção O somatório dos pesos da sazonalidade ser 100%',
            action_inactivate_seasonality: 'Deseja Realmente inativar a sazonalidade',
            value_percent: 'Valor %',
            first_quarter: 'Q1',
            second_quarter: 'Q2',
            third_quarter: 'Q3',
            fourth_quarter: 'Q4',
            select_type: 'Selecione o tipo de sazonalidade',
        },
        triggers: {
            trigger_title: 'Cadastro de Gatilho',
            trigger_name_table: 'Nome do Gatilho',
            trigger_name: 'Nome correspondente ao gatilho',
            interval_value: 'Valor do intervalo',
            final_value: 'Valor final',
            add_range: 'Adicionar Intervalo',
            delete_last_range: 'Excluir último intervalo',
            interval: 'Intervalo',
            warning_trigger: 'O somatório dos itens do gatilho preciso ser de 100%',
            bonus: 'Bônus',
            bonus_above_one_hundred: 'Insira o percentual de bônus',
            action_inactivate_triggers: 'Deseja Realmente inativar o gatilho',
            triger_item_value_not_defined: 'Valor do gatilho não definido',
            order_modal: 'Ordem',
            initial_value_modal: 'Valor Inicial do Intervalo',
            final_value_modal: 'Valor Final do Intervalo',
        },
        messages: {
            goal_required_field_missing: 'Campos obrigatórios não preenchidos na meta',
            trigger_item_not_found: 'Item de gatilho não encontrado',
            triger_item_value_not_defined: 'Valor do item de gatilho não definido',
            clearance_sale_reward_not_defined: 'Recompensa de Saldão não definida',
            triger_item_not_defined: 'Item de gatilho não definido',
            reason_required: 'Obrigatório o preenchimento do campo "Motio"',
            brands_required: 'Campo marca é obrigatório',
            goal_already_exists: 'Meta já está cadastrada',
            brand_already_registered: 'Marca já está cadastrada',
            result_not_found: 'Resultado não esperado',
        },
        validations: {
            invalid_credentials: 'Credenciais Inválidas',
            brand_create_success: 'Marca criada com sucesso',
            brand_create_fail: 'Erro ao criar marca',
            brand_update_success: 'Marca atualizada com sucesso',
            brand_update_fail: 'Erro ao atualizar marca',
            brand_delete_success: 'Marca excluída com sucesso',
            brand_delete_fail: 'Erro ao excluir marca',
            missing_required_fields: 'Campos obrigatórios não preenchidos',
            configuration_not_found: 'Configuração não encontrada',
            configuration_create_success: 'Configuração criada com sucesso',
            configuration_create_fail: 'Erro ao cadastrar configuração',
            configuration_update_success: 'Configuração atualizada com sucesso',
            configuration_update_fail: 'Erro ao atualizar configuração',
            start_date_greater_than_end_date: 'Data inicial maior que a data final',
            error_consulting_database: 'Erro ao consultar o banco de dados',
            goal_required_field_missing: 'Campos obrigatórios não preenchidos na meta',
            trigger_item_not_found: 'Item do Gatilho não encontrado',
            triger_item_value_not_defined: 'Valor do Item do Gatilho não definido',
            clearance_sale_reward_not_defined: 'Valor da recompensa do Saldão não definido',
            reason_required: 'Motivo é obrigatório',
            users_ids_null: 'Usuário não deve ser nulo ou indefinido',
            roles_ids_null: 'Função não deve ser nulo ou indefinido',
            seasons_ids_null: 'Sazonalidade não deve ser nulo ou indefinido',
            performants_null: 'Performante não deve ser nulo ou indefinido',
            goal_liness_null: 'As Linhas das metas não deve ser nulo ou indefinido',
            goal_user_not_found: 'Colaborador não encontrado',
            goal_role_not_found: 'Função não encontrado',
            goal_seller_not_found: 'Vendedor não encontrado',
            goal_already_exists: 'Meta já existe',
            invoice_not_found: 'Nota Fiscal não encontrada',
            item_not_found: 'Item não encontrada',
            performant_not_found: 'Performante não encontrada',
            preview_not_found: 'Prévia não encontrada',
            provision_not_found: 'Provisão não encontrada',
            reception_not_found: 'Recebimento não encontrado',
            resale_create_success: 'Parceiro de Negócios criada com sucesso',
            resale_create_fail: 'Erro ao criar parceiro de negócios',
            resale_update_success: 'Parceiro de negócios atualizada com sucesso',
            resale_update_fail: 'Erro ao atualizar parceiro de negócios',
            resale_delete_fail: 'Erro ao excluir parceiro de negócios',
            resale_delete_success: 'Parceiro de negócios excluída com sucesso',
            role_not_found: 'Função não encontrada',
            role_create_success: 'Função criada com sucesso',
            role_create_fail: 'Erro ao criar função',
            role_update_success: 'Função atualizada com sucesso',
            role_update_fail: 'Erro ao atualizar função',
            role_delete_fail: 'Erro ao excluir função',
            role_delete_success: 'Função excluída com sucesso',
            season_not_found: 'Sazonalidade não encontrada',
            season_hundred_error: 'O somatório dos pesos da sazonalidade precisa ser 100%',
            season_create_success: 'Sazonalidade criada com sucesso',
            season_create_fail: 'Erro ao criar sazonalidade',
            season_delete_fail: 'Erro ao excluir sazonalidade',
            season_delete_success: 'Sazonalidade excluída com sucesso',
            trigger_not_found: 'Gatilho não encontrado',
            trigger_items_not_set: 'Os intervalos do gatilho não foram preenchidos',
            trigger_item_value_error: 'Erro na passagem de valor dos itens do gatilho',
            trigger_item_hundred_error: 'O somatório dos itens do gatilho precisa ser 100%',
            trigger_item_create_fail: 'Erro ao criar Itens do gatilho',
            trigger_create_success: 'Gatilho criado com sucesso',
            trigger_create_fail: 'Erro ao criar gatilho',
            trigger_item_delete_fail: 'Erro ao excluir o item do gatilho',
            trigger_delete_fail: 'Erro ao excluir o gatilho',
            trigger_delete_success: 'Gatilho excluído com sucesso',
            user_not_found: 'Usuário não encontrado',
            user_create_success: 'Usuário criado com sucesso',
            user_create_fail: 'Erro ao criar usuário',
            user_update_success: 'Usuário atualizado com sucesso',
            user_update_fail: 'Erro ao atualizar usuário',
            user_delete_success: 'Usuário excluído com sucesso',
            user_delete_fail: 'Erro ao excluir usuário',
            preference_not_set: 'Preferência não setada',
            user_preference_success: 'Preferência do usuário não setado',
            user_preference_fail: 'Erro ao criar Usuário da preferência',
            warehouse_create_success: 'Depósito criado com sucesso',
            warehouse_create_fail: 'Erro ao criar depósito',
            warehouse_update_success: 'Depósito atualizado com sucesso',
            warehouse_update_fail: 'Erro ao atualizar depósito',
            warehouse_delete_success: 'Depósito excluído com sucesso',
            warehouse_delete_fail: 'Erro ao excluir depósito',
            unauthorized: 'Não autorizado',
            InternalServer_Error: 'Ops..Ocorreu um erro inesperado no sistema, por favor contacte o suporte',
            only_image_allowed: 'Somente arquivos do tipo imagem são permitidos',
            resale_already_exists: 'Parceiro de negócios já existe',
            sap_users_id: 'O campo "Registro no SAP" não pode ser vazio',
            sap_card_code: 'O campo "Código do Parceiro de Negócios" não pode ser vazio',
            sap_card_name: 'O campo "Nome" não pode ser vazio',
            sap_code: 'O campo "Código no SAP" não pode ser vazio',
            company: 'O campo "Base do Depósito" não pode ser vazio',
            start_date: 'O campo "Data de início" não pode ser vazio',
            end_date: 'O campo "Data de fim" não pode ser vazio',
            jan: 'O campo "Janeiro" não pode ser vazio',
            feb: 'O campo "Fevereiro" não pode ser vazio',
            mar: 'O campo "Março" não pode ser vazio',
            apr: 'O campo "Abril" não pode ser vazio',
            may: 'O campo "Maio" não pode ser vazio',
            jun: 'O campo "Junho" não pode ser vazio',
            jul: 'O campo "Julho" não pode ser vazio',
            aug: 'O campo "Agosto" não pode ser vazio',
            sep: 'O campo "Setembro" não pode ser vazio',
            oct: 'O campo "Outubro" não pode ser vazio',
            nov: 'O campo "Novembro" não pode ser vazio',
            dec: 'O campo "Dezembro" não pode ser vazio',
            brands_required: 'Informe a marca a ser adicionada',
            brand_already_registered: 'Marca já cadastrada na meta',
            items_required: 'Item não informado',
            invoice_or_item_not_found: 'Item ou Nota Fiscal não encontrado',
            item_update_fail: 'Erro ao atualizar o item',
            item_update_success: 'Item atualizado com sucesso',
        },
        breadcrumbs: {
            invoices: 'Notas',
            goals: 'Metas',
            reports: 'Relatórios',
            settings: 'Configurações',
        },
        edit_invoice: {
            warning_message: 'Nenhuma margem foi alterada',
            verify_message: 'Tem certeza de que deseja salvar as alterações na margem das notas fiscais?',
            success_message: 'Notas alteradas com sucesso',
            customer_code: 'Cód do cliente',
            customer_name: 'Nome do cliente',
            item_total: 'Total do item',
            btn_title: 'Alterar margem da nota fiscal',
            title_edit: 'Alterar valor da margem do item',
        },
        status: {
            invoiced: 'Faturado',
            cancelled: 'Cancelado',
            returned: 'Devolvido',
            return_cancelled: 'Devolução Cancelada'
        },
        goals_group: {
            goal_group_created_successfully: 'Grupo de metas criada com sucesso!',
            create_group: 'Criar grupo',
            create_new_group: 'Criar novo grupo',
            select_group: 'Selecionar grupo',
            view_group_details: 'Ver detalhes do grupo',
        }
    },
};